import { useSampleContext } from "../../contexts";
import ScanWizard from "./ScanWizard";
import CustomModalT from "../ui/ModalT";
import { useGetMeasurementTrace, useValidateSample } from "../../api";

const WasatchWizardTrace = ({ step, steps, changeStep, pageID }) => {
  const { initWasatchTrace, device, addReachbackReason, removeReachbackReason } = useSampleContext();

  return (
    <ScanWizard
      title='Amplifi ID Trace Scan'
      subtitle='If Trace Scan is not applicable, press "Skip Trace Scan".'
      step={step}
      pageID={pageID}
      changeStep={changeStep}
      deviceId={device?.deviceId}
      getMeasurementHook={useGetMeasurementTrace}
      scanType='trace-burst'
      validateHook={useValidateSample}
      initContextScan={initWasatchTrace}
      reachback={{
        addReachbackReason,
        removeReachbackReason,
        reasonKey: "traceErrorCheck",
      }}
      infoModal={({ showModal, handleClose }) => (
        <CustomModalT showModal={showModal} handleClose={handleClose} />
      )}
    />
  );
};

export default WasatchWizardTrace;
